import { stateFromCookie } from './attribution'

export const PENDING_ATTRIBUTION_KEY = 'agm_attribution_pending'
export const OVERFLOW_ATTRIBUTION_KEY = 'agm_attribution_state'

const safely = fn => {
  try {
    return fn()
  } catch {
    return null
  }
}

const read = key =>
  safely(() => stateFromCookie(window.sessionStorage.getItem(key)))

const write = (key, state) =>
  safely(() => window.sessionStorage.setItem(key, JSON.stringify(state)))

const clear = key => safely(() => window.sessionStorage.removeItem(key))

export const readPendingAttribution = () => read(PENDING_ATTRIBUTION_KEY)

export const writePendingAttribution = state =>
  write(PENDING_ATTRIBUTION_KEY, state)

export const clearPendingAttribution = () => clear(PENDING_ATTRIBUTION_KEY)

export const readOverflowState = () => read(OVERFLOW_ATTRIBUTION_KEY)

export const writeOverflowState = state =>
  write(OVERFLOW_ATTRIBUTION_KEY, state)

export const clearOverflowState = () => clear(OVERFLOW_ATTRIBUTION_KEY)
